export enum ContactFormType {
  APPLICATIONS = 'applications',
  RESOURCES = 'resources',
  DEFAULT = 'default',
  PIPELINE_DATA = 'pipeline-data',
  AUTO_DOCKING = 'auto-docking',
  CUSTOMER_CASE = 'customer-case',
  MARITIME = 'maritime',
  NAVY_DEFENCE = 'navy-defence',
  AERONAUTICS = 'aeronautics',
  MOBILE_MACHINES = 'mobile-machines',
  PLATFORM = 'platform',
  CAREERS = 'careers',
  ARTICLES = 'articles',
}

export type ContactFormProps = {
  type?: ContactFormType;
  backgroundColor?: string;
  onClick?: () => void;
};

export type TypeData = {
  title: string;
  description: string;
  buttonLabel: string;
};
